export const viewBiteContainerCy = 'view-bite-container';
